const t = "_trigger_1wcu8_1", c = "_entity_1wcu8_16", n = "_icon_1wcu8_26", e = {
  trigger: t,
  entity: c,
  icon: n
};
export {
  e as default,
  c as entity,
  n as icon,
  t as trigger
};
//# sourceMappingURL=index.es5615.js.map
